export const FETCH_PROFILE = "FETCH_PROFILE";
export const FETCH_PROFILE_OK = "FETCH_PROFILE_OK";
export const FETCH_PROFILE_FAILED = "FETCH_PROFILE_FAILED";

// export const FETCH_USER_ID = "FETCH_USER_ID";
// export const FETCH_USER_ID_OK = "FETCH_USER_ID_OK";
// export const FETCH_USER_ID_FAILED = "FETCH_USER_ID_FAILED";

// export const PATCH_USER = "PATCH_USER";
// export const PATCH_USER_OK = "PATCH_USER_OK";
// export const PATCH_USER_FAILED = "PATCH_USER_FAILED";

// export const RESET_USER = "RESET_USER";

// export const ATTACH_COMPANY = "ATTACH_COMPANY";
// export const ATTACH_COMPANY_OK = "ATTACH_COMPANY_OK";
// export const ATTACH_COMPANY_FAILED = "ATTACH_COMPANY_FAILED";

// export const DELETE_ATTACHED_COMPANY = "DELETE_ATTACHED_COMPANY";
// export const DELETE_ATTACHED_COMPANY_OK = "DELETE_ATTACHED_COMPANY_OK";
// export const DELETE_ATTACHED_COMPANY_FAILED = "DELETE_ATTACHED_COMPANY_FAILED";

// export const FETCH_ATTACHED_COMPANIES = "FETCH_ATTACHED_COMPANIES";
// export const FETCH_ATTACHED_COMPANIES_OK = "FETCH_ATTACHED_COMPANIES_OK";
// export const FETCH_ATTACHED_COMPANIES_FAILED =
//   "FETCH_ATTACHED_COMPANIES_FAILED";
